import * as React from "react";
import { RANDOMCOLORS } from "../utils/utils";
const { useState, useEffect } = React;

const MAINCOLORS = [
  "#8DD1E1",
  "#82CA9D",
  "#A4DE6C",
  "#8884D8",
  "#83A6ED",
  "#D0ED57",
  "#DCAD00",
  "#FFC658",
  "#FF8042",
  "#00C49F",
  "#B7B5E8",
];

const getChartBarsData = (data) => {
  const filteredData = data.filter((stat) => stat.count > 0);
  const randomColors = filteredData.length - MAINCOLORS.length;
  const barColors = [
    ...MAINCOLORS,
    ...(randomColors > 0 ? RANDOMCOLORS(randomColors) : []),
  ];
  return filteredData.map((e: any, index) => {
    e.name = e.name;
    e.fill = barColors[index];
    return e;
  });
};
type returned = [any, React.Dispatch<React.SetStateAction<any>>];

const useColorsChartBars = (data) => {
  const [state, setState] = useState(() => data);
  useEffect(() => setState(getChartBarsData(data)), [data]);
  return [state, setState] as returned;
};

export default useColorsChartBars;



// WEBPACK FOOTER //
// ./src/share/hooks/useChartBarsColors.ts